import { render, staticRenderFns } from "./assetsadd.html?vue&type=template&id=38e88bd4&scoped=true&external"
import script from "./assetsadd.vue?vue&type=script&lang=js"
export * from "./assetsadd.vue?vue&type=script&lang=js"
import style0 from "./assetsadd.vue?vue&type=style&index=0&id=38e88bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e88bd4",
  null
  
)

export default component.exports